import React, { useState } from 'react';

import mediaImages from '../assets/data/media';

function MediaPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const openModal = (index) => {
    setSelectedIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  return (
    <section className="px-[15vw] py-12">
      <h1 className="text-center text-3xl font-bold mb-6">미디어자료</h1>
      <p className="text-center mb-16 text-sm text-gray-600">
        * 본 페이지에 올라온 자료는 라이프스팬 제품의 공식 판매자들을 위한
        것입니다.
        <br />
        허가받지 않은 사람이 무단으로 사용할 경우 법적 책임을 질 수 있습니다.
        <br />* 사진을 클릭하시면 큰 사이즈로 보실 수 있습니다.
      </p>
      <hr className="mb-16"></hr>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {mediaImages.map((fileName, idx) => (
          <img
            key={idx}
            src={`/images/media/${fileName}`} // public 폴더 기준 절대 경로
            alt={`미디어 이미지 ${idx + 1}`}
            className="w-[150px] h-[100px] object-cover cursor-pointer rounded border border-gray-300 shadow-sm hover:shadow-lg transition"
            onClick={() => openModal(idx)}
          />
        ))}
      </div>

      {/* 모달 */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <img
            src={`/images/media/${mediaImages[selectedIndex]}`}
            alt={`미디어 이미지 ${selectedIndex + 1}`}
            className="max-w-[90vw] max-h-[90vh] rounded shadow-lg"
            onClick={(e) => e.stopPropagation()} // 모달 내부 클릭 시 닫히지 않도록
          />
        </div>
      )}
    </section>
  );
}

export default MediaPage;
